import { FC, useContext, useEffect, useState } from "react";
import {
  Typography,
  Container,
  useMediaQuery,
  Box,
  Grid,
  Button,
  useTheme,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import MobileView from "../SubComponents/Projects/MobileView";
import DesktopView from "../SubComponents/Projects/DesktopView";
import { AllProjectStyle } from "../Styles/LandingStyles";

import { useGraphQLQuery } from "../../utils/grapgql/react-query-graphql.util";
import gql from "graphql-tag";
import AlertContext from "../../store/Alert/AlertContext";
import NoDataFound from "../../helpers/NoDataFound";
import Loader from "../../helpers/Loader";
import Pagination from "../../helpers/Pagination";

const TRACK_RECORD_QUERY = gql`
  query getTrackRecordList {
    getTrackRecordList(trackListInput: { rows: 10, page: 1 }) {
      rows {
        id
        name
        image
        contributionStartDate
        contributionEndDate
        status
        ath
        poolTokenPrice
        coingeckoProjectId
      }
      page
      totalPages
      count
    }
  }
`;

const Projects: FC = () => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("md"));
  const isActivexs = useMediaQuery(theme.breakpoints.down("xs"));
  const { setAlert } = useContext<any>(AlertContext);
  const [dataa, setDataa] = useState<any>();
  const [noData, setNoData] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalPosts, setTotalPosts] = useState(0);
  const { data, error, isLoading } = useGraphQLQuery<any, any, any>(
    TRACK_RECORD_QUERY
  );
  const [filteredData, setFilteredData] = useState<any[]>([]);

  useEffect(() => {
    if (data) {
      setDataa(data);
    }
    if (error) {
      setAlert(error?.message, "error");
    }
  }, [data, error]);
  
  useEffect(() => {
    if (dataa) {
      const filtered = filterOnClosed();
      setFilteredData(filtered);
      setNoData(filtered.length === 0);
    }
  }, [dataa]); // Runs whenever `dataa` updates

  function handleClickPagination() {
    setLoader(false);
    setTotalPosts((prevValue) => prevValue + 2);
  }

  function filterOnClosed() {
    if (!dataa?.getTrackRecordList?.rows) return [];
  
    const closedRecords = dataa.getTrackRecordList.rows.filter(
      (row: { status: string }) => row.status === "closed"
    );
  
    // Separate records with null/undefined coingeckoProjectId
    const nullProjectIdRecords: typeof closedRecords = [];
    const earliestRecords: Record<string, typeof closedRecords[0]> = {};
  
    closedRecords.forEach((row: any) => {
      if (!row.coingeckoProjectId) {
        // If coingeckoProjectId is null or undefined, always include it
        nullProjectIdRecords.push(row);
      } else {
        // Keep only the earliest entry per coingeckoProjectId
        if (
          !earliestRecords[row.coingeckoProjectId] ||
          new Date(row.contributionStartDate) <
            new Date(earliestRecords[row.coingeckoProjectId].contributionStartDate)
        ) {
          earliestRecords[row.coingeckoProjectId] = row;
        }
      }
    });
  
    return [...nullProjectIdRecords, ...Object.values(earliestRecords)];
  }
  

  const handleMoreData = (e: any) => {
    e.preventDefault();
    let bottom =
      e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop < 10;
    setLoader(true);
    if (bottom) {
      handleClickPagination();
    }
  };

  // const [priceClass, setPriceClass] = useState('green');
  const classes = AllProjectStyle();
  return (
    <>
      <Box
        data-aos="fade-up"
        data-aos-duration="1200"
        className={classes.projects}
        component="section"
      >
        <Container className={classes.relative} fixed>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid
              item
              md={12}
              sm={12}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                className="projectdesc"
                mt={10}
                ml={5}
                textAlign={"center"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h2" color="primary">
                  {" "}
                  <Typography
                    className="aspekta-regular white"
                    style={{ fontSize: isActive ? "28px" : "40px" }}
                  >
                    Our <span className="aspekta-semiBold">Track Record</span>
                  </Typography>
                  <br />
                </Typography>
              </Box>
            </Grid>
            {!isActive && (
              <>
                {error ? (
                  <Grid item md={12} sm={12}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="white aspekta-medium"
                            align="center"
                          >
                            Project
                          </TableCell>
                          <TableCell
                            className="white aspekta-medium"
                            align="center"
                          >
                            Price
                          </TableCell>
                          <TableCell
                            className="white aspekta-medium"
                            align="center"
                          >
                            ATH ROI
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <Box textAlign="center" mt={2}>
                        <Typography variant="h3">Can't Fetch Data</Typography>
                      </Box>
                    </Table>
                  </Grid>
                ) : (
                  <Grid className="scroller" item md={12} sm={12}>
                    {/* desktop layout */}

                    <TableContainer
                      onScroll={handleMoreData}
                      className="MuiPaper-rounded"
                    >
                      <Table aria-label="sticky table">
                        <TableHead>
                          <TableRow style={{ backgroundColor: "transparent" }}>
                            <TableCell
                              className="white font-family-Poppin fw-bold"
                              align="center"
                            >
                              Project
                            </TableCell>
                            <TableCell
                              className="white font-family-Poppin fw-bold"
                              align="center"
                            >
                              IDO Price
                            </TableCell>
                            <TableCell
                              className="white font-family-Poppin fw-bold"
                              align="center"
                              style={{
                                textAlign: "center",
                              }}
                            >
                              ATH ROI
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {filteredData
                            ?.slice(0, 999)
                            .map((datas: any, index: any) => {
                              const { id, name, image, ath, poolTokenPrice } =
                                datas;
                              return (
                                <>
                                  {noData ? (
                                    <NoDataFound title="No more pools available!" />
                                  ) : (
                                    <DesktopView
                                      key={index}
                                      id={id}
                                      imgSrc={image}
                                      title={name}
                                      price={poolTokenPrice}
                                      roi={(
                                        (ath) /
                                        poolTokenPrice
                                      ).toString()}
                                      change=""
                                    />
                                  )}
                                </>
                              );
                            })}
                        </TableBody>
                        {loader && <Loader />}
                        {isLoading && <Loader />}
                        {/* {totalPosts < filterOnClosed()?.length && (
                          <Box className="nomargin">
                            <Pagination
                              handleClick={handleClickPagination}
                              isLoading={isLoading}
                            />
                          </Box>
                        )} */}
                      </Table>
                    </TableContainer>
                  </Grid>
                )}
              </>
            )}
            {/* mobile layout */}
            {isActive && (
              <Grid item xs={12} className="scroller">
                {error ? (
                  <Box textAlign="center">
                    <Typography variant="h5" className="fw-normal">
                      Cann't Fetch Data
                    </Typography>
                  </Box>
                ) : (
                  <Box className="lessrecords">
                    {filteredData
                      ?.slice(0, 999)
                      .map((dataa: any, index: any) => {
                        const { id, name, image, ath, poolTokenPrice } = dataa;
                        return (
                          <>
                            {noData ? (
                              <NoDataFound title="No more pools available!" />
                            ) : (
                              <MobileView
                                key={index}
                                id={id}
                                imgSrc={image}
                                title={name}
                                price={poolTokenPrice}
                                roi={(
                                  (ath) /
                                  poolTokenPrice
                                ).toString()}
                                change=""
                              />
                            )}
                          </>
                        );
                      })}
                    {isLoading && <Loader />}
                    {/* {totalPosts < filterOnClosed()?.length && (
                      <Box className="nomargin">
                        <Pagination
                          handleClick={handleClickPagination}
                          isLoading={isLoading}
                        />
                      </Box>
                    )} */}
                  </Box>
                )}
              </Grid>
            )}

            {/* <Grid item xs={12}>
              <Box textAlign="center" mt={5} mb={isActivexs ? 5 : 5}>
                <Button
                  variant="contained"
                  className="hero-blue-bg white"
                  size="large"
                  href="/project-pools"
                >
                  View All Projects
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Projects;
